export const dlCartOpenEvent = () => {
    window.dataLayer.push({
        event: 'open_cart'
    });
};
